// extracted by mini-css-extract-plugin
module.exports = {"menuSkeleton":"menuSkeleton_3zqcS"};